import { render } from "./TravelComponent.vue?vue&type=template&id=c56c2316"
import script from "./TravelComponent.vue?vue&type=script&lang=js"
export * from "./TravelComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__